import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { formatMoneyColumnHeader } from "@common/helpers/number";
import {
    AR_AGING_BUCKET_LABELS,
    AR_AGING_BUCKET_ORDER,
} from "@common/types/reports/ar-aging";
import { PreviewArAgingSummaryDataset } from "./previewTypes";
import { previewRowPercent } from "./previewPercent";
import { AmountCell } from "./AmountCell";
import { PercentCell } from "./PercentCell";
import styles from "./ReportPreview.module.scss";

interface Props {
    dataset: PreviewArAgingSummaryDataset;
    numberFormat: NumberFormatValues;
}

export const ArAgingSummaryTable = ({ dataset, numberFormat }: Props) => (
    <div className={styles.table}>
        <div className={styles.columnHeader} data-columns="ar-aging-summary">
            <span>{dataset.customerHeader}</span>
            {AR_AGING_BUCKET_ORDER.map((bucket) => (
                <span key={bucket} className={styles.amountCell}>
                    {formatMoneyColumnHeader(
                        AR_AGING_BUCKET_LABELS[bucket],
                        numberFormat,
                    )}
                </span>
            ))}
            <span className={styles.amountCell}>
                {formatMoneyColumnHeader(dataset.totalHeader, numberFormat)}
            </span>
            <span className={styles.percentCell}>{dataset.percentHeader}</span>
        </div>
        {dataset.rows.map((row) => (
            <div
                key={row.id}
                className={styles.gridRow}
                data-columns="ar-aging-summary"
                data-kind={row.kind}
                data-top-border={row.hasTopBorder || undefined}
            >
                <span>{row.label}</span>
                {AR_AGING_BUCKET_ORDER.map((bucket) => (
                    <AmountCell
                        key={bucket}
                        value={row.buckets[bucket]}
                        numberFormat={numberFormat}
                    />
                ))}
                <AmountCell value={row.total} numberFormat={numberFormat} />
                <PercentCell
                    value={previewRowPercent({
                        amount: row.total,
                        percentBase: dataset.percentBase,
                    })}
                    numberFormat={numberFormat}
                />
            </div>
        ))}
    </div>
);
